
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/sections/components/StageSideArea/Actions/Actions.scss.css.virtualfile';
        module.exports = {"actionsArea":"_actionsArea_14v95_7","mobile":"_mobile_14v95_18","fixed":"_fixed_14v95_20","invisibleContainer":"_invisibleContainer_14v95_23"};